import cookie from 'react-cookies';

/**
 * Пполучение YA clientId из yacounter
 */
const getYmClientId = (): string | undefined =>  {
    try {
        return  window['yaCounter30080914']?.getClientID();
    } catch (e) {
        console.error('window.ym is not defined');
    }
};

const COOKIE_YM_ID = '_ym_uid';

interface IResultGetYAId {
    ymUid: string | undefined,
}

export const getYmIdValue = (): string | undefined => {
    const clientYAId: string | undefined = cookie.load(COOKIE_YM_ID);
    return  clientYAId || getYmClientId();
};

export const getYmId = (): IResultGetYAId => {
    return {
        ymUid: getYmIdValue(),
    };
};

